import React from "react"
import { Link, Redirect } from "react-router-dom"
import Logo from "../../common/Logo"
import moment from "moment"
import { API } from "../../api"
import { connect } from "react-redux"
import { showNotificationWithTimeout } from "../../_actions/adminAlertActionCreator"
import Loader from "../../common/Loader"
import pixel from "../../landing/pixel"
import { logInUser } from "../../_actions/userActionCreator"
import { ROUTES, sessionData, cacheData } from "../../common/utils"

import "./SubscriptionPayment.css"

class SubscriptionPayment extends React.Component {
  constructor(props) {
    super(props)
    this.PaymentRedirect.bind(this)
    this.state = {
      isSubmitting: false,
      subsID: null,
      fetching: false,
      paymentDone: false
    }
  }

  async loginUser(user) {
    return new Promise(async function(resolve, reject) {
      try {
        sessionData("Qarabao_User", user)
        logInUser(user)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  getPlanName(plan) {
    switch (plan) {
      case "standard":
        return "direct_seller"
      case "plus":
        return "online_seller"
      case "premium":
        return "direct_online"
      default:
        return null
    }
  }

  async PaymentRedirect() {
    const { plan, rate, user } = this.props.location.state
    let userAccount = (this.props.user.account && this.props.user) || user
    const { account } = userAccount
    try {
      const subsType = `${this.getPlanName(plan.toLowerCase())}`
      this.setState({ fetching: true })
      const response = await API.post(
        `/accounts/paypal/subscribe`,
        JSON.stringify({
          subscription_type: subsType
        })
      )
      if (
        response &&
        response.data &&
        response.data.redirect &&
        response.data.redirect !== ""
      ) {
        cacheData("Qarabao_User", this.props.user)
        pixel.track("Subscribe", {
          value: rate,
          currency: "PHP",
          predicted_ltv: "2450"
        })
        window.gtag("event", "conversion", {
          send_to: "AW-779168230/XytfCJuzlJ0BEObTxPMC",
          transaction_id: account.email
        })
        window.location.assign(response.data.redirect)
      } else {
        this.setState({ fetching: false })
      }
    } catch (error) {
      console.log(error)
      if (error && error.response) {
        console.log(error.response)
      }
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message ===
          "You already have a PAYPAL subscription!"
      ) {
        if (error.response.data.meta_data) {
          const meta = JSON.parse(error.response.data.meta_data)
          meta &&
            meta.links &&
            meta.links[0] &&
            window.location.assign(meta.links[0].href)
        }
      } else {
        this.setState({ fetching: false })
        this.props.showAlert({
          message: "Something went wrong.",
          type: "error",
          consumer: "admin"
        })
      }
    }

    // const { rate, plan, user } = this.props.location.state
    // if (user && user.token) {
    //   await this.loginUser(user)
    //   API.defaults.headers.common["x-access-token"] = user.token
    // }
    // this.setState(
    //   state => ({
    //     ...state,
    //     isSubmitting: true
    //   }),
    //   async () => {
    //     let userAccount = (this.props.user.account && this.props.user) || user
    //     const { account } = userAccount
    //     const referrer = `${window.location.origin}/admin?plan=`
    //     const subsType = `${plan.toLowerCase()}_seller`
    //     try {
    //       const paymayaBody = {
    //         subscription_type: subsType,
    //         totalAmount: {
    //           currency: "PHP",
    //           value: rate,
    //           details: {
    //             shippingFee: "",
    //             tax: "",
    //             subTotal: "",
    //             discount: ""
    //           }
    //         },
    //         buyer: {
    //           firstName: account.first_name,
    //           middleName: "",
    //           lastName: account.last_name,
    //           contact: {
    //             phone: account.mobile_country_code + account.mobile,
    //             email: account.email
    //           },
    //           shippingAddress: {},
    //           billingAddress: {},
    //           ipAddress: ""
    //         },
    //         items: [
    //           {
    //             name: `Subscription - ${subsType
    //               .replace("_", " ")
    //               .toUpperCase()}`,
    //             code: "",
    //             description: "",
    //             quantity: "",
    //             amount: {
    //               value: rate
    //             },
    //             totalAmount: {
    //               value: rate
    //             }
    //           }
    //         ],
    //         redirectUrl: {
    //           success: `${referrer}${subsType}`,
    //           failure: `${referrer}${subsType}`,
    //           cancel: `${referrer}${subsType}`
    //         },
    //         requestReferenceNumber: account.uuid,
    //         metadata: {}
    //       }

    //       const response = await API.post(
    //         `/accounts/subscription/payment/paymaya`,
    //         JSON.stringify(paymayaBody)
    //       )
    //       if (response) {
    //         pixel.track("Subscribe", {
    //           value: rate,
    //           currency: "PHP",
    //           predicted_ltv: "2450"
    //         })
    //         window.gtag("event", "conversion", {
    //           send_to: "AW-779168230/XytfCJuzlJ0BEObTxPMC",
    //           transaction_id: account.email
    //         })
    //         const { redirectUrl } = response.data
    //         window.location.href = redirectUrl
    //       }
    //     } catch (error) {
    //       console.log(error)
    //       const { redirectUrl, checkoutId } = error.response.data.data
    //       if (
    //         error.response.data.message ===
    //         "You already have a pending payment request for PAYMAYA!"
    //       ) {
    //         window.location.href = redirectUrl
    //       } else {
    //         window.location.href = `${referrer}?error=${
    //           error.response.data.message
    //         }&redirectUrl=${redirectUrl}&checkoutId=${checkoutId}`
    //       }
    //     }
    //   }
    // )
  }

  render() {
    const { plan } =
      (this.props.location.state && this.props.location.state) || ""
    return this.state.paymentDone ? (
      <Redirect
        to={{
          pathname: "/admin",
          state: { from: this.props.location }
        }}
      />
    ) : (
      (!this.state.fetching && (
        <div className="SubscriptionPayment">
          <div className="SubscriptionPayment-container">
            <Logo />
            <h1>
              You have selected <br />
              {plan} plan
            </h1>
            <p>
              Proceed with subscription or{" "}
              <span>
                <Link
                  to={{
                    pathname: ROUTES.TRIAL_EXPIRY
                  }}
                  className="change-plan-link"
                >
                  Change plan
                </Link>
              </span>
            </p>
            <button
              className="q-orange"
              onClick={this.PaymentRedirect.bind(this)}
            >
              Set up payment now
            </button>
          </div>
          <p>&copy; Qarabao, {moment().format("Y")}</p>
        </div>
      )) || <Loader />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  showAlert: alert => {
    showNotificationWithTimeout(dispatch, alert)
  }
})

export default connect(
  state => ({
    user: state.user,
    adminAlert: state.adminAlert
  }),
  mapDispatchToProps
)(SubscriptionPayment)
